import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { InsightsPage } from '#features/insights/insights-page.tsx'

export const Route = createFileRoute('/_app/$workspace/_dashboard/insights/')({
  component: InsightsPage,
  pendingComponent: DefaultLoader,
})
